import BaseStore from 'nast-store'

/**
 *
 */
export default class NastStore extends BaseStore {

}
